// @ts-nocheck
import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import HomePage from 'components/pages/home/HomePage';

import { getPageValues } from 'support/analytics/analyticsHelper';

import useTracking from 'hooks/analytics';

const trackHome = tracker => {
  const pageData = {
    pageType: 'main',
    ...getPageValues('main'),
  };

  tracker(pageData);
};

const Home = ({ onError }) => {
  const { trackPage: tracker } = useTracking();
  useEffect(() => {
    trackHome(tracker);
  }, [tracker]);

  return (
    <Switch>
      <Route path="/">
        <HomePage onError={onError} />
      </Route>
    </Switch>
  );
};

Home.propTypes = {
  onError: PropTypes.func,
};

Home.defaultProps = {
  onError: () => {},
};

export default Home;
